module.exports = __webpack_public_path__ + "static/playing_card_set-b457ee54a0f6ad87ca3c27da506b46de.jpg";